export default "__VITE_ASSET__eb58300b__"